import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Icon, Radio, RadioButtonGroup } from '@salesforce/design-system-react';

import './Weather.scss';

class Weather extends Component {
  constructor(props) {
    super(props);
    this.getI18nID = suffix => `components.ecs.rules.weather.${suffix}`;
  }

  degreeSetting() {
    const { formatMessage } = this.props.intl;

    const activateInfo = (
      <div className="weather-setup-info">
        <div className="info-banner activate-info-banner slds-grid">
          <div className="info-icon slds-col">
            <Icon category="utility" name="info" size="small" />
          </div>
          <div className="slds-col">
            <FormattedMessage id={this.getI18nID('legalInfo')} />
            <br />
            <FormattedMessage id={this.getI18nID('activateInfo')} />
          </div>
        </div>
      </div>
    );

    const deactivatingInfo = (
      <div className="weather-setup-info">
        <div className="info-banner activate-warning-banner slds-grid">
          <div style={{ color: 'black' }}>
            <div className="slds-current-color info-icon slds-col">
              <Icon category="utility" name="warning" size="small" />
            </div>
          </div>
          <div className="slds-col">
            <FormattedMessage id={this.getI18nID('deactivateInfo')} />
          </div>
        </div>
      </div>
    );

    const degreeSetting = (
      <div className="weather-setup-info">
        <div className="degree-toggle">
          <div className="degree-toggle-label">
            <FormattedMessage id={this.getI18nID('temperatureUnits')} />
          </div>
          <RadioButtonGroup
            className="degree-radio"
            onChange={(event, { value }) =>
              this.props.onSettingChanged('weather_degree', event.target.value)
            }
          >
            <Radio
              key="fahrenheit"
              id="fahrenheit"
              labels={{
                label: formatMessage({
                  id: this.getI18nID('toggle.fahrenheit')
                })
              }}
              value="F"
              checked={this.props.weatherDegree === 'F'}
              variant="button-group"
            />
            <Radio
              key="celsius"
              id="celsius"
              labels={{
                label: formatMessage({
                  id: this.getI18nID('toggle.celsius')
                })
              }}
              value="C"
              checked={this.props.weatherDegree === 'C'}
              variant="button-group"
            />
          </RadioButtonGroup>
        </div>
      </div>
    );

    return this.props.isWeather
      ? degreeSetting
      : this.props.isWeatherDeleting
      ? deactivatingInfo
      : activateInfo;
  }

  render() {
    return <div className="weather slds-grid">{this.degreeSetting()}</div>;
  }
}

Weather.propTypes = {
  isWeather: PropTypes.bool,
  isWeatherDeleting: PropTypes.bool,
  weatherDegree: PropTypes.string,
  onSettingChanged: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(Weather);
